import React from 'react';

import { SVGProps } from './SVG.props';

const NewLogo = (props: SVGProps): React.JSX.Element => {
  const { width, height, fill } = props;
  return (
    <svg
      width={width || '243'}
      height={height || '60'}
      viewBox="0 0 243 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_591_8074)">
        <ellipse
          cx="23.9837"
          cy="23.3327"
          rx="18.3631"
          ry="18.6667"
          fill="#91DBB6"
        />
        <path
          d="M55.8363 16.0292V11.3574H75.4304V16.0292H68.3946V35.117H62.8714V16.0292H55.8362H55.8363Z"
          fill="black"
        />
        <path
          d="M93.9092 24.3051V35.117H88.9775V25.3066C88.9775 23.2373 87.794 21.7691 85.8213 21.7691C83.9149 21.7691 82.3368 23.3377 82.3368 25.5065V35.1172H77.405V11.3574H82.3368V19.9673C83.4542 18.2984 85.4601 17.3641 87.4981 17.3641C91.3444 17.3641 93.909 20.2342 93.909 24.3051H93.9092Z"
          fill="black"
        />
        <path
          d="M110.002 29.6788L114.308 30.647C113.421 33.6168 109.969 35.7857 105.991 35.7857C100.567 35.7857 96.7197 31.948 96.7197 26.442C96.7197 21.1027 100.567 17.3652 105.991 17.3652C111.383 17.3652 115.065 21.1027 115.065 26.5083C115.065 26.9426 115.065 27.6433 114.999 28.0105L101.816 27.9772C102.243 30.3799 103.887 31.9479 106.122 31.9479C107.898 31.9479 109.41 30.9803 110.002 29.6786V29.6788ZM110.068 24.9737C109.772 22.8049 108.128 21.2031 105.892 21.2031C103.723 21.2031 102.21 22.7045 101.783 24.9737H110.068Z"
          fill="black"
        />
        <path
          d="M123.764 35.117V11.3574H131.062L137.67 28.7432L144.213 11.3574H151.61V35.117H146.218V18.1317L139.742 35.117H135.599L129.155 18.1317V35.117H123.763H123.764Z"
          fill="black"
        />
        <path
          d="M168.806 18.0327H173.738V35.1183H168.806V32.7488C167.491 34.6514 165.486 35.7857 163.086 35.7857C158.352 35.7857 155.031 31.9817 155.031 26.5755C155.031 21.1692 158.352 17.3652 163.086 17.3652C165.486 17.3652 167.491 18.4995 168.806 20.4021V18.0326V18.0327ZM168.773 26.5755C168.773 23.8056 166.932 21.7702 164.368 21.7702C161.804 21.7702 159.963 23.8056 159.963 26.5755C159.963 29.3453 161.804 31.3807 164.368 31.3807C166.933 31.3807 168.773 29.3453 168.773 26.5755Z"
          fill="black"
        />
        <path
          d="M189.26 17.8327V22.2708C188.307 21.8704 187.222 21.6367 186.499 21.6367C184.362 21.6367 182.948 23.4722 182.948 26.0415V35.1183H178.016V18.0327H182.75V20.2016C183.737 18.4995 185.381 17.3984 187.255 17.3984C187.912 17.3984 188.603 17.5658 189.26 17.8327H189.26Z"
          fill="black"
        />
        <path
          d="M192.898 21.8357H190.531V18.0312H193.128L193.687 13.7266H197.83V18.0312H201.643V21.8357H197.83V29.0769C197.83 30.5114 198.684 31.4796 200.065 31.4796C200.525 31.4796 201.249 31.3794 201.807 31.2459L201.775 35.2503C200.788 35.5838 199.473 35.7842 198.421 35.7842C195.067 35.7842 192.898 33.2148 192.898 29.5777V21.8359V21.8357Z"
          fill="black"
        />
        <path
          d="M217.122 29.6788L221.428 30.647C220.541 33.6168 217.089 35.7857 213.111 35.7857C207.687 35.7857 203.84 31.948 203.84 26.442C203.84 21.1027 207.687 17.3652 213.111 17.3652C218.503 17.3652 222.185 21.1027 222.185 26.5083C222.185 26.9426 222.185 27.6433 222.119 28.0105L208.936 27.9772C209.364 30.3799 211.007 31.9479 213.243 31.9479C215.018 31.9479 216.53 30.9803 217.122 29.6786V29.6788ZM217.188 24.9737C216.892 22.8049 215.248 21.2031 213.012 21.2031C210.843 21.2031 209.33 22.7045 208.903 24.9737H217.188Z"
          fill="black"
        />
        <path
          d="M237.739 24.7399C237.311 22.905 235.635 21.5702 233.76 21.5702C231.361 21.5702 229.487 23.6721 229.487 26.5755C229.487 29.4788 231.328 31.5807 233.76 31.5807C235.7 31.5807 237.311 30.2459 237.771 28.411L242.374 29.0114C241.749 32.9494 238.067 35.7857 233.727 35.7857C228.435 35.7857 224.555 31.9148 224.555 26.5755C224.555 21.2362 228.402 17.3652 233.727 17.3652C238.133 17.3652 241.815 20.2016 242.341 24.1395L237.739 24.7399Z"
          fill="black"
        />
        <path
          d="M47.1375 23.5715C47.1375 10.5428 36.6795 0 23.7558 0C10.8321 0 0.374023 10.5428 0.374023 23.5715C0.374023 36.6001 10.8321 47.1428 23.7558 47.1428C26.6254 47.1428 29.3674 46.6285 31.8969 45.6643C28.1345 49.5001 23.4157 52.35 18.2929 53.8071L20.0147 60C27.6669 57.8358 34.5752 53.1001 39.4428 46.7143C44.4805 40.1143 47.1375 32.2071 47.1375 23.8714V23.5715V23.5715ZM6.75097 23.5715C6.75097 14.1214 14.3818 6.42854 23.7558 6.42854C33.1298 6.42854 40.7607 14.1214 40.7607 23.5715C40.7607 33.0216 33.1297 40.7143 23.7558 40.7143C14.382 40.7143 6.75097 33.0214 6.75097 23.5715V23.5715Z"
          fill="#12100E"
        />
        <path
          d="M23.7557 29.9998C27.2775 29.9998 30.1325 27.1216 30.1325 23.5712C30.1325 20.0209 27.2775 17.1426 23.7557 17.1426C20.234 17.1426 17.3789 20.0208 17.3789 23.5712C17.3789 27.1217 20.2338 29.9998 23.7557 29.9998V29.9998Z"
          fill="#12100E"
        />
      </g>
      <defs>
        <clipPath id="clip0_591_8074">
          <rect
            width="242"
            height="60"
            fill="white"
            transform="translate(0.374023)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NewLogo;
